/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitalBills } from 'app/entities/hospital-bill/hospital-bill.reducer';
import { DiscountType } from 'app/shared/model/enumerations/discount-type.model';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';
import { createEntity, getEntity, reset, updateEntity } from './hospital-bill-discount.reducer';

export const HospitalBillDiscountUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitalBills = useAppSelector(state => state.hospitalBill.entities);
  const hospitalBillDiscountEntity = useAppSelector(state => state.hospitalBillDiscount.entity);
  const loading = useAppSelector(state => state.hospitalBillDiscount.loading);
  const updating = useAppSelector(state => state.hospitalBillDiscount.updating);
  const updateSuccess = useAppSelector(state => state.hospitalBillDiscount.updateSuccess);
  const discountTypeValues = Object.keys(DiscountType);
  const billTypeValues = Object.keys(BillType);

  const handleClose = () => {
    navigate(`/hospital-bill-discount${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitalBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...hospitalBillDiscountEntity,
      ...values,
      bill: hospitalBills.find(it => it.id.toString() === values.bill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          discountType: 'NONE',
          billType: 'OP',
          ...hospitalBillDiscountEntity,
          microSec: convertDateTimeFromServer(hospitalBillDiscountEntity.microSec),
          timestampEntry: convertDateTimeFromServer(hospitalBillDiscountEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(hospitalBillDiscountEntity.lastUpdated),
          bill: hospitalBillDiscountEntity?.bill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.hospitalBillDiscount.home.createOrEditLabel" data-cy="HospitalBillDiscountCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.hospitalBillDiscount.home.createOrEditLabel">
              Create or edit a HospitalBillDiscount
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-bill-discount-id"
                  label={translate('tinyMedicRestApp.hospitalBillDiscount.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.discountType')}
                id="hospital-bill-discount-discountType"
                name="discountType"
                data-cy="discountType"
                type="select"
              >
                {discountTypeValues.map(discountType => (
                  <option value={discountType} key={discountType}>
                    {translate(`tinyMedicRestApp.DiscountType.${discountType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.billType')}
                id="hospital-bill-discount-billType"
                name="billType"
                data-cy="billType"
                type="select"
              >
                {billTypeValues.map(billType => (
                  <option value={billType} key={billType}>
                    {translate(`tinyMedicRestApp.BillType.${billType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.discount')}
                id="hospital-bill-discount-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.active')}
                id="hospital-bill-discount-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.microSec')}
                id="hospital-bill-discount-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.timestampEntry')}
                id="hospital-bill-discount-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.lastUpdated')}
                id="hospital-bill-discount-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillDiscount.cursor')}
                id="hospital-bill-discount-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="hospital-bill-discount-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.hospitalBillDiscount.bill')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalBills
                  ? hospitalBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/hospital-bill-discount" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalBillDiscountUpdate;
